@import 'styles/variables';

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.buttonRow {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  align-items: center;
  padding: 0 12px 12px 12px;
}
